export default "__VITE_ASSET__B2G2Qn9C__"